export const LIST_GENERAL_FEE_REQUEST = 'LIST_GENERAL_FEE_REQUEST'
export const LIST_GENERAL_FEE_SUCCESS = 'LIST_GENERAL_FEE_SUCCESS'
export const LIST_GENERAL_FEE_FAIL = 'LIST_GENERAL_FEE_FAIL'

export const LIST_GENERAL_FEE_SUMMARY_REQUEST = 'LIST_GENERAL_FEE_SUMMARY_REQUEST'
export const LIST_GENERAL_FEE_SUMMARY_SUCCESS = 'LIST_GENERAL_FEE_SUMMARY_SUCCESS'
export const LIST_GENERAL_FEE_SUMMARY_FAIL = 'LIST_GENERAL_FEE_SUMMARY_FAIL'

export const CREATE_GENERAL_FEE_REQUEST = 'CREATE_GENERAL_FEE_REQUEST'
export const CREATE_GENERAL_FEE_SUCCESS = 'CREATE_GENERAL_FEE_SUCCESS'
export const CREATE_GENERAL_FEE_FAIL = 'CREATE_GENERAL_FEE_FAIL'

export const DETAIL_GENERAL_FEE_REQUEST = 'DETAIL_GENERAL_FEE_REQUEST'
export const DETAIL_GENERAL_FEE_SUCCESS = 'DETAIL_GENERAL_FEE_SUCCESS'
export const DETAIL_GENERAL_FEE_FAIL = 'DETAIL_GENERAL_FEE_FAIL'

export const UPDATE_GENERAL_FEE_REQUEST = 'UPDATE_GENERAL_FEE_REQUEST'
export const UPDATE_GENERAL_FEE_SUCCESS = 'UPDATE_GENERAL_FEE_SUCCESS'
export const UPDATE_GENERAL_FEE_FAIL = 'UPDATE_GENERAL_FEE_FAIL'

export const DELETE_GENERAL_FEE_REQUEST = 'DELETE_GENERAL_FEE_REQUEST'
export const DELETE_GENERAL_FEE_SUCCESS = 'DELETE_GENERAL_FEE_SUCCESS'
export const DELETE_GENERAL_FEE_FAIL = 'DELETE_GENERAL_FEE_FAIL'

export const RESET_GENERAL_FEE = 'RESET_GENERAL_FEE'
